import { createContext } from 'react';
import { ChangeCostCenterContextProps } from './change-cost-center.types';

export const ChangeCostCenterContext = createContext<ChangeCostCenterContextProps>({} as ChangeCostCenterContextProps);
